import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { SummaryPaneResult } from 'src/apps/mobile-common/types/CommonTypes';
import { getMobileSdkTestSummary } from 'src/apps/mobile-sdk/services/MobileSdkSingleTestService';
import { MOBILE_SDK_TEST_SUMMARY } from 'src/common/providers/reactQueryProvider/QueryKeys';

interface IUseMobileSdkTestSummaryQuery {
	testId: string;
}

export const useMobileSdkTestSummaryQuery = ({
	testId
}: IUseMobileSdkTestSummaryQuery): UseQueryResult<SummaryPaneResult> => {
	const testSummaryQuery = useQuery(
		[MOBILE_SDK_TEST_SUMMARY, testId],
		async (): Promise<SummaryPaneResult> =>
			getMobileSdkTestSummary({
				testId
			})
	);

	return testSummaryQuery;
};
